import { render, staticRenderFns } from "./StandardLayout.vue?vue&type=template&id=5f78edf8&scoped=true"
import script from "./StandardLayout.vue?vue&type=script&lang=js"
export * from "./StandardLayout.vue?vue&type=script&lang=js"
import style0 from "./StandardLayout.vue?vue&type=style&index=0&id=5f78edf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f78edf8",
  null
  
)

export default component.exports